var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StatusFilter'),_vm._v(" "),_c('div',{staticClass:"filter-row"},[_c('DateFilter'),_vm._v(" "),_c('GroupFilter',{attrs:{"groups":_vm.groups}}),_vm._v(" "),_c('FullTextSearch')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }